"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _treater = require("@/api/treater");
var _org = require("@/api/org");
var _doctor_commission = require("@/api/doctor_commission");
var _treater_commission = require("@/api/treater_commission");
var _region = require("@/api/region");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _file = require("@/api/file");
var _config_diseaseclass = require("@/api/config_diseaseclass");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultTreater = {
  // id: '',
  real_name: '',
  treatername: '',
  dept: null,
  mobile: '',
  sex: '',
  // 1 未知  2 男  3 女
  addrs: '',
  birthdate: null,
  recommender: null,
  treater_type: 1,
  // 1 普通TTS操作师 2 总TTS操作师
  province_code: '',
  city_code: '',
  district_code: '',
  zip_code: '',
  accounts_name: '',
  accounts_no: '',
  disease_class: null
};
var defaultCommission = {
  // id: '',
  treater: null,
  prescre_type: 2,
  dept: null,
  prescre_rate: 0,
  prescre_amount: 0,
  treat_status: null,
  commission_status: null,
  name: '',
  type: ''
};
var phoneValidator = function phoneValidator(rule, value, callBack) {
  var reg = /^[1][0-9]{10}$/;
  if (value) {
    if (!reg.test(value)) {
      callBack('请输入正确的手机号码');
    } else {
      callBack();
    }
  } else {
    callBack();
  }
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      treater: defaultTreater,
      treaterData: [],
      treaterList: {
        count: 0
      },
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 20,
        status: 1 // 1 正常 2 禁用 3 待审核
      },
      statusOptions: [{
        key: 1,
        display_name: '正常'
      }, {
        key: 2,
        display_name: '禁用'
      }, {
        key: 3,
        display_name: '待审核'
      }],
      sexOptions: [{
        key: 2,
        display_name: '男'
      }, {
        key: 3,
        display_name: '女'
      }],
      treaterTypeOptions: [{
        key: 1,
        display_name: '普通TTS操作师'
      }, {
        key: 2,
        display_name: '总TTS操作师'
      }],
      commissionTypeObj: {
        prescre: '开方佣金',
        treat: '调理佣金'
      },
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        real_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }, {
          max: 10,
          message: '输入长度不能超过10位'
        }],
        treatername: [{
          required: true,
          message: '请输入账号',
          trigger: 'change'
        }, {
          max: 10,
          message: '输入长度不能超过10位'
        }],
        dept: [{
          required: true,
          message: '请选择所属部门',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'change'
        }],
        mobile: [{
          required: true,
          message: '请选择手机号码',
          trigger: 'blur'
        }, {
          max: 11,
          message: '输入长度不能超过11位'
        }, {
          validator: phoneValidator
        }],
        accounts_name: [{
          required: true,
          message: '请输入银行开户行',
          trigger: 'blur'
        }],
        accounts_no: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        disease_class: [{
          required: true,
          message: '请选择科室',
          trigger: 'change'
        }]
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'change' }
        // ],
      },
      filterOrgText: '',
      treeLoding: false,
      orgData: [],
      orgData_origin: [],
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      // 审核
      dialogSignVisible: false,
      dialogSignType: 'new',
      commission: [],
      listSignLoading: true,
      deptData: {},
      dialogCommissionVisible: false,
      dialogCommissionType: 'new',
      commissionObj: defaultCommission,
      commissionStatusOptions: [{
        key: 1,
        display_name: '比例分成'
      }, {
        key: 2,
        display_name: '固定金额分成'
      }],
      commissionStatusOptionsObj: {
        1: '比例分成',
        2: '固定金额分成'
      },
      rule2: {
        treat_status: [{
          required: true,
          message: '请选择佣金分成类型',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请选择佣金分成对象',
          trigger: 'blur'
        }]
      },
      commissionNameOptions: [],
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      api: process.env.VUE_APP_BASE_API,
      orgData1: [],
      options: []
    };
  },
  computed: {},
  watch: {
    filterOrgText: function filterOrgText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.getList();
    this.getOrgAll();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getOrg();
    this.getDiseaseclass();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      console.log(res.data);
      this.treater.enclosure = res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传封面图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleOrgClick: function handleOrgClick(obj, node, vue) {
      this.listQuery.page = 1;
      this.listQuery.dept = obj.id;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _treater.getTreaterList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.treaterList = response.data;
          _this.treaterData = (0, _utils.genTree)(response.data.results);
        }
        _this.listLoading = false;
      });
    },
    getProvinceAll: function getProvinceAll() {
      var _this2 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this2.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this3 = this;
      this.cityData = [];
      this.treater.city_code = '';
      this.treater.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this3.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.id === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this4 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this4.defaultCity = response.data;
        _this4.cityData = [];
        _this4.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this4.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this5 = this;
      this.districtData = [];
      this.treater.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this5.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.id === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this6 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this6.defaultDistrict = response.data;
        _this6.districtData = [];
        _this6.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this6.districtData.push(item_district);
        });
      });
    },
    getOrgAll: function getOrgAll() {
      var _this7 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this7.orgData_origin = response.data;
        _this7.orgData = (0, _utils.genTree)(response.data);
        _this7.treeLoding = false;
      });
    },
    getOrg: function getOrg() {
      var _this8 = this;
      (0, _org.getDoctorOrg)({
        commission_id: 4
      }).then(function (response) {
        _this8.orgData1 = (0, _utils.genTree)(response.data);
      });
    },
    getDiseaseclass: function getDiseaseclass() {
      var _this9 = this;
      (0, _config_diseaseclass.getDiseaseClassAll)().then(function (response) {
        _this9.options = response.data;
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20,
        status: 1
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAddTreater: function handleAddTreater() {
      var _this10 = this;
      this.treater = Object.assign({}, defaultTreater);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this10.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this11 = this;
      this.treater = Object.assign({}, scope.row); // copy obj
      this.cityData = [];
      if (this.treater.province_code) {
        var province_code = this.provinceData.filter(function (item) {
          return item.id === _this11.treater.province_code;
        })[0].province_code;
        this.defaultCity.forEach(function (item) {
          if (item.province_code === province_code) {
            var item_city = Object.assign({}, item);
            _this11.cityData.push(item_city);
          }
        });
      }
      this.districtData = [];
      if (this.treater.city_code) {
        var city_code = this.cityData.filter(function (item) {
          return item.id === _this11.treater.city_code;
        })[0].city_code;
        this.defaultDistrict.forEach(function (item) {
          if (item.city_code === city_code) {
            var item_district = Object.assign({}, item);
            _this11.districtData.push(item_district);
          }
        });
      }
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this11.$refs['Form'].clearValidate();
      });
    },
    handleForbidden: function handleForbidden(scope) {
      var _this12 = this;
      this.treater = Object.assign({}, scope.row);
      this.treater.status = 2;
      this.$confirm('确认禁用?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _treater.updateTreater)(_this12.treater.id, _this12.treater);
            case 2:
              _this12.getList();
              _this12.dialogVisible = false;
              _this12.$message({
                type: 'success',
                message: '成功禁用!'
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleRecover: function handleRecover(scope) {
      var _this13 = this;
      this.treater = Object.assign({}, scope.row);
      this.treater.status = 1;
      this.$confirm('确认恢复?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _treater.updateTreater)(_this13.treater.id, _this13.treater);
            case 2:
              _this13.getList();
              _this13.dialogVisible = false;
              _this13.$message({
                type: 'success',
                message: '成功禁用!'
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this14 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _treater.deleteTreater)(scope.row.id);
            case 2:
              _this14.getList();
              // this.treaterList.splice(scope.$index, 1)
              _this14.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleSign: function handleSign(type, scope) {
      var _this15 = this;
      this.listSignLoading = true;
      this.dialogSignType = type;
      this.commission = [];
      this.dialogSignVisible = true;
      this.deptData = null;
      this.deptData = {
        treater_id: scope.row.id,
        treater_name: scope.row.real_name,
        treater_dept: scope.row.dept,
        dept_data: []
      };
      var dept = scope.row.dept;
      while (dept) {
        var dept_item = this.orgData_origin.filter(function (item) {
          return item.id === dept;
        })[0];
        // 移除新汉方
        // this.deptData.dept_data.push({ id: dept_item.id, name: dept_item.name })
        // dept = dept_item.parent
        dept = dept_item.parent;
        if (dept) {
          this.deptData.dept_data.push({
            id: dept_item.id,
            name: dept_item.name
          });
        }
      }
      // console.log('deptData', this.deptData)
      (0, _treater_commission.getCommissionTreatList)({
        page: 1,
        page_size: 100,
        treater: scope.row.id
      }).then(function (res) {
        var treat_data = res.data.results.map(function (item) {
          if (item.dept) {
            item.name = item.dept_name;
          } else {
            item.name = item.treater_name;
          }
          item.type = 'treat';
          return item;
        });
        (0, _doctor_commission.getCommissionPrescreList)({
          page: 1,
          page_size: 100,
          treater: scope.row.id
        }).then(function (res) {
          var prescre_data = res.data.results.map(function (item) {
            if (item.dept) {
              item.name = item.dept_name;
            } else {
              item.name = item.treater_name;
            }
            item.type = 'prescre';
            item.treat_status = item.commission_status;
            return item;
          });
          _this15.commission = prescre_data.concat(treat_data);
          _this15.listSignLoading = false;
        });
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this16 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this16.dialogType === 'edit';
                  if (isEdit) {
                    (0, _treater.updateTreater)(_this16.treater.id, _this16.treater).then(function (res) {
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _treater.createTreater)(_this16.treater).then(function (res) {
                      _this16.getList();
                      _this16.dialogVisible = false;
                      _this16.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleAddCommission: function handleAddCommission(val) {
      var _this17 = this;
      this.commissionObj = Object.assign({}, defaultCommission);
      this.commissionObj.type = val;
      this.commissionNameOptions = null;
      this.commissionNameOptions = [];
      // 不能添加TTS操作师本身
      // if (!this.commission.filter(item => item.dept === null).length && val === 'prescre') {
      //   this.commissionNameOptions.push({ dept: null, name: this.deptData.treater_name })
      // }
      this.deptData.dept_data.forEach(function (dept) {
        if (!_this17.commission.filter(function (item) {
          return item.dept === dept.id && item.type === val;
        }).length) {
          _this17.commissionNameOptions.push({
            dept: dept.id,
            name: dept.name
          });
        }
      });
      // console.log('xxx', this.commissionNameOptions)
      if (!this.commissionNameOptions.length) {
        this.$message({
          type: 'warning',
          message: '没有更多的佣金对象可配置'
        });
      } else {
        this.commissionObj.treater = this.deptData.treater_id;
        this.dialogCommissionType = 'new';
        this.dialogCommissionVisible = true;
        this.$nextTick(function () {
          _this17.$refs['CommissionForm'].clearValidate();
        });
      }
    },
    selectNameChange: function selectNameChange(val) {
      this.commissionObj.dept = val;
      this.commissionObj.name = this.commissionNameOptions.filter(function (item) {
        return item.dept === val;
      })[0].name;
    },
    handleEditCommission: function handleEditCommission(scope) {
      var _this18 = this;
      this.commissionObj = Object.assign({}, scope.row);
      if (scope.row.dept) {
        this.commissionObj.name = scope.row.dept_name;
      } else {
        this.commissionObj.name = scope.row.treater_name;
      }
      this.dialogCommissionType = 'edit';
      this.dialogCommissionVisible = true;
      this.$nextTick(function () {
        _this18.$refs['Form'].clearValidate();
      });
    },
    handleDeleteCommission: function handleDeleteCommission(scope) {
      var _this19 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var index;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(scope.row.type === 'treat')) {
                _context5.next = 5;
                break;
              }
              _context5.next = 3;
              return (0, _treater_commission.deleteCommissionTreat)(scope.row.id);
            case 3:
              _context5.next = 7;
              break;
            case 5:
              _context5.next = 7;
              return (0, _doctor_commission.deleteCommissionPrescre)(scope.row.id);
            case 7:
              index = null;
              _this19.commission.every(function (value, i) {
                // console.log('value', value)
                // console.log('scope', scope.row)
                // console.log('iii', i)
                if (value['id'] === scope.row.id) {
                  index = i;
                  return false;
                }
                return true;
              });
              _this19.commission.splice(index, 1);
              _this19.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    selectCommissionTypeChange: function selectCommissionTypeChange(val) {
      this.commissionObj.commission_status = val;
      this.commissionObj.prescre_rate = 0;
      this.commissionObj.prescre_amount = 0;
    },
    confirmCommission: function () {
      var _confirmCommission = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this20 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this20.dialogCommissionType === 'edit';
                  if (isEdit) {
                    if (_this20.commissionObj.type === 'treat') {
                      (0, _treater_commission.updateCommissionTreat)(_this20.commissionObj.id, _this20.commissionObj).then(function (res) {
                        (0, _treater_commission.getCommissionTreatList)({
                          page: 1,
                          page_size: 100,
                          treater: _this20.deptData.treater_id
                        }).then(function (res) {
                          var treat_data = res.data.results.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.treater_name;
                            }
                            item.type = 'treat';
                            return item;
                          });
                          (0, _doctor_commission.getCommissionPrescreList)({
                            page: 1,
                            page_size: 100,
                            treater: _this20.deptData.treater_id
                          }).then(function (res) {
                            var prescre_data = res.data.results.map(function (item) {
                              if (item.dept) {
                                item.name = item.dept_name;
                              } else {
                                item.name = item.treater_name;
                              }
                              item.type = 'prescre';
                              item.treat_status = item.commission_status;
                              return item;
                            });
                            _this20.commission = prescre_data.concat(treat_data);
                            _this20.dialogCommissionVisible = false;
                            _this20.$message({
                              message: '编辑成功',
                              type: 'success'
                            });
                          });
                        });
                      });
                    } else {
                      (0, _doctor_commission.updateCommissionPrescre)(_this20.commissionObj.id, _this20.commissionObj).then(function (res) {
                        (0, _treater_commission.getCommissionTreatList)({
                          page: 1,
                          page_size: 100,
                          treater: _this20.deptData.treater_id
                        }).then(function (res) {
                          var treat_data = res.data.results.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.treater_name;
                            }
                            item.type = 'treat';
                            return item;
                          });
                          (0, _doctor_commission.getCommissionPrescreList)({
                            page: 1,
                            page_size: 100,
                            treater: _this20.deptData.treater_id
                          }).then(function (res) {
                            var prescre_data = res.data.results.map(function (item) {
                              if (item.dept) {
                                item.name = item.dept_name;
                              } else {
                                item.name = item.treater_name;
                              }
                              item.type = 'prescre';
                              item.treat_status = item.commission_status;
                              return item;
                            });
                            _this20.commission = prescre_data.concat(treat_data);
                            _this20.dialogCommissionVisible = false;
                            _this20.$message({
                              message: '编辑成功',
                              type: 'success'
                            });
                          });
                        });
                      });
                    }
                  } else {
                    if (_this20.commissionObj.type === 'treat') {
                      (0, _treater_commission.createCommissionTreat)(_this20.commissionObj).then(function (res) {
                        (0, _treater_commission.getCommissionTreatList)({
                          page: 1,
                          page_size: 100,
                          treater: _this20.deptData.treater_id
                        }).then(function (res) {
                          var treat_data = res.data.results.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.treater_name;
                            }
                            item.type = 'treat';
                            return item;
                          });
                          (0, _doctor_commission.getCommissionPrescreList)({
                            page: 1,
                            page_size: 100,
                            treater: _this20.deptData.treater_id
                          }).then(function (res) {
                            var prescre_data = res.data.results.map(function (item) {
                              if (item.dept) {
                                item.name = item.dept_name;
                              } else {
                                item.name = item.treater_name;
                              }
                              item.type = 'prescre';
                              item.treat_status = item.commission_status;
                              return item;
                            });
                            _this20.commission = prescre_data.concat(treat_data);
                            _this20.dialogCommissionVisible = false;
                            _this20.$message({
                              message: '新增成功',
                              type: 'success'
                            });
                          });
                        });
                      });
                    } else {
                      (0, _doctor_commission.createCommissionPrescre)(_this20.commissionObj).then(function (res) {
                        (0, _treater_commission.getCommissionTreatList)({
                          page: 1,
                          page_size: 100,
                          treater: _this20.deptData.treater_id
                        }).then(function (res) {
                          var treat_data = res.data.results.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.treater_name;
                            }
                            item.type = 'treat';
                            return item;
                          });
                          (0, _doctor_commission.getCommissionPrescreList)({
                            page: 1,
                            page_size: 100,
                            treater: _this20.deptData.treater_id
                          }).then(function (res) {
                            var prescre_data = res.data.results.map(function (item) {
                              if (item.dept) {
                                item.name = item.dept_name;
                              } else {
                                item.name = item.treater_name;
                              }
                              item.type = 'prescre';
                              item.treat_status = item.commission_status;
                              return item;
                            });
                            _this20.commission = prescre_data.concat(treat_data);
                            _this20.dialogCommissionVisible = false;
                            _this20.$message({
                              message: '新增成功',
                              type: 'success'
                            });
                          });
                        });
                      });
                    }
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmCommission(_x2) {
        return _confirmCommission.apply(this, arguments);
      }
      return confirmCommission;
    }(),
    confirmSign: function confirmSign() {
      var _this21 = this;
      (0, _treater.updateTreater)(this.deptData.treater_id, {
        status: 1
      }).then(function (res) {
        _this21.getList();
        _this21.dialogSignVisible = false;
        _this21.$message({
          message: '审核成功',
          type: 'success'
        });
      });
    }
  }
};